import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  bottomRowWrapper: {
    flexDirection: 'row',
    height: Theme.px(60),
    marginTop: Theme.px(64),
    paddingLeft: Theme.px(48),
  },
  logoAndTimeWrapper: {
    height: '100%',
  },
});
